import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileTypePipe } from './file-tipes.pipe';

@NgModule({
  declarations: [FileTypePipe],
  imports: [CommonModule],
  exports: [FileTypePipe],
})
export class FileTipesPipeModule {}
